export function calculateDailyMoveFromVix(vixLevel: number): { dailyMovePercent: number | null; isValid: boolean; message?: string } {
  if (vixLevel == null || isNaN(vixLevel)) {
    return { dailyMovePercent: null, isValid: false, message: 'Ogiltigt VIX-värde' };
  }
  if (vixLevel < 0) {
    return { dailyMovePercent: null, isValid: false, message: 'VIX kan inte vara negativt' };
  }
  const dailyMovePercent = vixLevel / 16; // Rule of 16
  if (!isFinite(dailyMovePercent)) {
    return { dailyMovePercent: null, isValid: false, message: 'Ogiltigt resultat' };
  }
  return { dailyMovePercent, isValid: true };
}


